import React from "react";
import { Mail, Phone, X, ExternalLink } from "lucide-react";

// Same support desk everywhere it's offered (Sidebar's "Help & Support" nav
// item, Confirmation.jsx's generation-error/rejected screens) - one shared
// constant so the email/phone can't drift out of sync between call sites.
export const SUPPORT_EMAIL = "support@easyfile2290.com";
// Same support line as the Form 720 reference's sidebar (Sidebar.jsx) - one
// shared support desk across both products, not a new number.
export const SUPPORT_PHONE_DISPLAY = "+1 (214) 471-9465";
export const SUPPORT_PHONE_TEL = "+12144719465";

export default function HelpSupportModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-[rgba(10,20,35,0.55)] z-[900] flex items-center justify-center p-5 backdrop-blur-[2px]"
      onClick={onClose}
    >
      <div
        className="bg-[var(--panel)] rounded-[18px] w-full max-w-[460px] shadow-[0_24px_64px_rgba(0,0,0,0.22)] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="bg-[var(--primary)] px-6 pt-6 pb-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-[18px] font-extrabold text-white tracking-[-0.02em] mb-[3px] font-disp">
                Help &amp; Support
              </div>
              <div className="text-[13px] text-[rgba(255,255,255,0.55)]">
                EasyFile2290 — Form 2290 e-Filing Platform
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-[30px] h-[30px] rounded-[8px] bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-[rgba(255,255,255,0.7)] cursor-pointer hover:bg-[rgba(255,255,255,0.18)] hover:text-white transition-colors flex-shrink-0"
            >
              <X size={14} strokeWidth={2.2} />
            </button>
          </div>
        </div>

        {/* Contact options */}
        <div className="px-6 py-5 flex flex-col gap-3">
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="flex items-center gap-3.5 px-4 py-3.5 border-[1.5px] border-[var(--line)] rounded-[12px] no-underline bg-[var(--panel)] hover:border-[var(--accent)] hover:bg-[var(--panel-2)] transition-all"
          >
            <div className="w-[42px] h-[42px] rounded-[11px] bg-[var(--panel-2)] flex items-center justify-center flex-shrink-0">
              <Mail size={20} strokeWidth={1.8} className="text-[var(--accent)]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-bold text-[var(--ink)] mb-[2px]">Email support</div>
              <div className="text-[13.5px] font-semibold text-[var(--accent)] truncate">{SUPPORT_EMAIL}</div>
              <div className="text-[12px] text-[var(--muted)] mt-px">Typical response within 1 business day</div>
            </div>
            <ExternalLink size={14} strokeWidth={1.8} className="text-[var(--muted)] flex-shrink-0 ml-1" />
          </a>

          <a
            href={`tel:${SUPPORT_PHONE_TEL}`}
            className="flex items-center gap-3.5 px-4 py-3.5 border-[1.5px] border-[var(--line)] rounded-[12px] no-underline bg-[var(--panel)] hover:border-[var(--ok)] hover:bg-[var(--panel-2)] transition-all"
          >
            <div className="w-[42px] h-[42px] rounded-[11px] bg-[var(--panel-2)] flex items-center justify-center flex-shrink-0">
              <Phone size={20} strokeWidth={1.8} className="text-[var(--ok)]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-bold text-[var(--ink)] mb-[2px]">Phone support</div>
              <div className="text-[13.5px] font-semibold text-[var(--ok)]">{SUPPORT_PHONE_DISPLAY}</div>
              <div className="text-[12px] text-[var(--muted)] mt-px">Mon–Fri, 9 AM – 6 PM CT</div>
            </div>
            <ExternalLink size={14} strokeWidth={1.8} className="text-[var(--muted)] flex-shrink-0 ml-1" />
          </a>
        </div>
      </div>
    </div>
  );
}
